import { render, staticRenderFns } from "./Mgr.vue?vue&type=template&id=6131b234&"
import script from "./Mgr.vue?vue&type=script&lang=js&"
export * from "./Mgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports